<div class="buttonContainer">
  <iris-button-container [alignment]="irisButtonContainerAlignments.END">
    <iris-button
      *ngIf="back && !resetArmed && !clientCqRedesignFeatureFlag"
      [ngClass]="['backButton', 'back-from-' + stepName]"
      (click)="backClicked.emit()"
      [disabled]="!!busy"
      [type]="irisButtonTypes.SECONDARY"
      data-test="back-button"
    >
      Back
    </iris-button>

    <iris-button
      *ngIf="back && !resetArmed && clientCqRedesignFeatureFlag"
      [ngClass]="['backButton', 'back-from-' + stepName]"
      class="back-with-arrow"
      (click)="backClicked.emit()"
      [disabled]="!!busy"
      [type]="irisButtonTypes.TERTIARY"
      [iconPosition]="irisButtonIconPositions.LEFT"
      data-test="back-button"
    >
      <iris-icon name="arrow_line_left"></iris-icon>
      Back
    </iris-button>

    <iris-button
      *ngIf="exit"
      [ngClass]="['exitButton', 'exit-from-' + stepName, confirmButtonGtmClass ?? '']"
      [fxHide]="resetArmed"
      [disabled]="!!busy || disabled"
      (click)="exitClicked.emit()"
    >
      Exit
    </iris-button>
    <iris-button
      *ngIf="exitAndSave"
      [ngClass]="['exitButton', 'exit-from-' + stepName, confirmButtonGtmClass ?? '']"
      [fxHide]="resetArmed"
      [disabled]="!!busy || disabled"
      (click)="exitAndSaveClicked.emit()"
    >
      {{ nextButtonName || "Exit" }}
    </iris-button>

    <iris-button
      *ngIf="showNextButton && !done && !clientCqRedesignFeatureFlag"
      [ngClass]="['nextButton', 'next-from-' + stepName, confirmButtonGtmClass ?? '']"
      [fxHide]="resetArmed"
      [disabled]="!!busy || disabled"
      (click)="nextClicked.emit()"
      data-test="next-submit-button"
    >
      {{ nextButtonName || "Next" }}
    </iris-button>
    <ng-container *ngIf="clientCqRedesignFeatureFlag && showNextButton && !done">
      <!-- This is a purposeful empty div that is used to appropriately space the 
       Next and Back buttons in the CQ redesign, which should be placed on the right and left
       respectively. This allows for the Next button to remain on the right even if the Back button
       is not present while still using the 'space-between' rule defined in the fullscreen messaging modal component -->
      <div class="empty"></div>
      <iris-button
        *ngIf="(nextButtonName == 'Next' || !nextButtonName); else nonIconNext"
        [ngClass]="['nextButton', 'next-from-' + stepName, confirmButtonGtmClass ?? '']"
        class="next-with-arrow"
        [fxHide]="resetArmed"
        [disabled]="!!busy || disabled"
        [type]="irisButtonTypes.TERTIARY"
        [iconPosition]="irisButtonIconPositions.RIGHT"
        (click)="nextClicked.emit()"
        data-test="next-submit-button"
      >
        <iris-icon name="arrow_line_right"></iris-icon>
        {{ nextButtonName || "Next" }}
      </iris-button>

      <ng-template #nonIconNext>
        <iris-button
          [ngClass]="['nextButton', 'next-from-' + stepName, confirmButtonGtmClass ?? '']"
          [fxHide]="resetArmed"
          [disabled]="!!busy || disabled"
          (click)="nextClicked.emit()"
          data-test="next-submit-button"
        >
          {{ nextButtonName || "Next" }}
        </iris-button>
      </ng-template>
    </ng-container>

    <iris-button
      *ngIf="dialNumber"
      [ngClass]="['callButton', 'call-from-' + stepName]"
      [fxHide]="resetArmed"
      linkHref="tel:{{ dialNumber }}"
    >
      Call
    </iris-button>
    <iris-button
      *ngIf="done"
      [ngClass]="['completeButton', 'complete-from-' + stepName, confirmButtonGtmClass ?? '']"
      [fxHide]="resetArmed"
      [disabled]="!!busy || disabled"
      (click)="nextClicked.emit()"
    >
      {{ done }}
    </iris-button>
  </iris-button-container>
</div>

<div class="buttonContainer resetContainer">
  <iris-button
    *ngIf="!busy && resetArmed"
    [ngClass]="['cancelButton', 'cancel-from-' + stepName]"
    [type]="irisButtonTypes.TERTIARY"
    (click)="disarm()"
  >
    Cancel
  </iris-button>
</div>
